import script from "./SaladCustomizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SaladCustomizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./SaladCustomizationModal.vue?vue&type=style&index=0&id=7f1706d0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f1706d0"]])

export default __exports__